module.exports = __webpack_public_path__ + "static/media/check.b08de1a4.svg";